module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"maintenance":{"title":"Estamos em manutenção","subtitle":"Estamos realizando uma manutenção programada para melhorar nossos produtos, logo estaremos de volta."}},"en-US":{"maintenance":{"title":"Under maintenance","subtitle":"We are performing a scheduled maintenance to improve our products, soon we\u0027ll be up again."}}}')
  delete Component.options._Ctor
}
